var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M17.932 16.274a10.05 10.05 0 0 0 2.16-6.22C20.091 4.522 15.58 0 10.031 0S0 4.52 0 10.055C0 15.589 4.51 20.11 10.032 20.11c2.214 0 4.428-.768 6.205-2.165L22.277 24 24 22.274zm-7.9 1.452c-4.182 0-7.6-3.425-7.6-7.616 0-4.192 3.418-7.617 7.6-7.617s7.599 3.425 7.599 7.617c0 4.191-3.417 7.616-7.599 7.616"}));
}

Search.defaultProps = {"width":"24","height":"24","fill":"none","viewBox":"0 0 24 24"};

module.exports = Search;

Search.default = Search;
